import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { CheckboxField, TimeRangeField } from '@frontend/design-system';
import { GetRuleExceptionFormFieldProps } from '../hooks/use-create-edit-rule-exception-form';

export const ExceptionTimeRangeField = ({ getFieldProps }: { getFieldProps: GetRuleExceptionFormFieldProps }) => {
  const { t } = useTranslation('schedule-settings');
  const isAllDayField = getFieldProps('isAllDay');

  return (
    <div css={timeFieldsStyles}>
      <CheckboxField {...isAllDayField} label={t('All-Day')} />
      <div css={separatorStyles}></div>
      <TimeRangeField
        {...getFieldProps('timeRange')}
        label={t('Exception Times')}
        joiningText={t('to')}
        disabled={isAllDayField.value}
      />
    </div>
  );
};

const timeFieldsStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(3.5),
};

const separatorStyles = {
  height: 50,
  borderRight: `1px solid ${theme.colors.neutral20}`,
};
